import { render, staticRenderFns } from "./UserAdminRequests.vue?vue&type=template&id=0d094d36&scoped=true"
import script from "./UserAdminRequests.vue?vue&type=script&lang=js"
export * from "./UserAdminRequests.vue?vue&type=script&lang=js"
import style0 from "./UserAdminRequests.vue?vue&type=style&index=0&id=0d094d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d094d36",
  null
  
)

export default component.exports